const POLLING_KEY = 'subscriptionPollingActive';
const POLLING_COUNT_KEY = 'subscriptionPollingCount';
const MAX_POLLING_ATTEMPTS = 10;

export const subscriptionPollingUtils = {
  startPolling: () => {
    localStorage.setItem(POLLING_KEY, Date.now().toString());
    localStorage.setItem(POLLING_COUNT_KEY, '0');
  },

  shouldPoll: (): boolean => {
    const pollingStartTime = localStorage.getItem(POLLING_KEY);
    const pollingCount = parseInt(localStorage.getItem(POLLING_COUNT_KEY) || '0', 10);

    if (!pollingStartTime) {
      return false;
    }

    if (pollingCount >= MAX_POLLING_ATTEMPTS) {
      subscriptionPollingUtils.stopPolling();
      return false;
    }

    return true;
  },

  incrementPollCount: () => {
    const currentCount = parseInt(localStorage.getItem(POLLING_COUNT_KEY) || '0', 10);
    localStorage.setItem(POLLING_COUNT_KEY, (currentCount + 1).toString());
  },

  stopPolling: () => {
    localStorage.removeItem(POLLING_KEY);
    localStorage.removeItem(POLLING_COUNT_KEY);
  },

  getPollCount: (): number => {
    return parseInt(localStorage.getItem(POLLING_COUNT_KEY) || '0', 10);
  },
};
